import React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';

import MobileWindow from './../Wrappers/MobileWindow';
import logo from '../../svg/nc-logo-w.svg';
import { instagram } from '../../services/api';
import { formatBigNumber } from '../../helpers';
import './Results.css';

interface InstagramPeriod {
  title: string;
  counters: any;
  period: string;
  actions: any;
}

class Results extends React.Component<{ goTo: any; id: any }, { data: any }> {
  state: { data: any } = { data: null };

  constructor(props: { goTo: any; id: any }) {
    super(props);
    instagram.getPeriods(props.id).then((data: any) => {
      this.setState({ data: data.data });
    });
  }

  render() {
    return (
      <MobileWindow page="monthlyReport">
        <img
          src={logo}
          alt="logo"
          className=""
          style={{ marginLeft: '30px', marginTop: '45px', width: '75px' }}
        />
        <div className="instagram-result-title">IG ACTION - ORGANIC RESULTS</div>
        {this.state.data ? (
          this.state.data.map((item: InstagramPeriod) => (
            <div className="instagram-result-container">
              <div className="instagram-result-item-name">{item.title}</div>
              <div className="instagram-result-data">
                {[
                  item.counters.reach
                    ? [
                        'Reach:',
                        <span className="instagram-result-data-value">
                          {' '}
                          {formatBigNumber(item.counters.reach)}{' '}
                        </span>,
                      ]
                    : null,
                  item.counters.likes
                    ? [
                        'Likes:',
                        <span className="instagram-result-data-value">
                          {' '}
                          {formatBigNumber(item.counters.likes)}{' '}
                        </span>,
                      ]
                    : null,
                  item.counters.comments
                    ? [
                        'Comments:',
                        <span className="instagram-result-data-value">
                          {' '}
                          {formatBigNumber(item.counters.comments)}{' '}
                        </span>,
                      ]
                    : null,
                ].map((item2: any, index) => (
                  <span key={item.title}>
                    {item2}
                    {index <
                      Number(item.counters.reach) +
                        Number(item.counters.comments) +
                        Number(item.counters.likes) -
                        1 && ' | '}
                  </span>
                ))}
              </div>
              <div
                className="instagram-results-button"
                onClick={() => {
                  this.props.goTo(`/instagram/${item.period}`);
                }}
              >
                View + Download | {item.actions.seen.count + item.actions.unseen.count} posts
              </div>
            </div>
          ))
        ) : (
          <div className="offer-loader" style={{ fontSize: '20px', paddingTop: '100px' }}>
            Loading results...
          </div>
        )}
        );
      </MobileWindow>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return { goTo: (url: string) => dispatch(push(url)) };
};
const mapStateToProps = (state: any) => ({ id: state.business.business_id });

export default connect(mapStateToProps, mapDispatchToProps)(Results);
